const SvgIconOpensource = (props) => (
  <svg viewBox="0 0 122 105" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36.4287 18.5005C36.4287 8.28295 44.7117 0 54.9292 0V0C65.1468 0 73.4297 8.28296 73.4297 18.5005V105H36.4287V18.5005Z"
      fill="#F2D6BB"
    />
    <path
      d="M84.5542 18.5005C84.5542 8.28295 92.8372 0 103.055 0V0C113.272 0 121.555 8.28296 121.555 18.5005V105H84.5542V18.5005Z"
      fill="#BC6038"
    />
    <ellipse cx="26.4293" cy="68.7499" rx="26.4293" ry="26.2499" fill="#EFAC26" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.4287 93.056V44.4436C46.0678 48.3594 52.8588 57.7669 52.8588 68.7498C52.8588 79.7327 46.0678 89.1402 36.4287 93.056Z"
      fill="#3763FF"
    />
  </svg>
);

export default SvgIconOpensource;
